import React from 'react';
import PropTypes from 'prop-types';

import { stagesDescription } from '../config';

export default function StageLabel({ stage }) {
  if (!stage) return null;

  return (
    <div>
      <div className="d-flex align-items-center">
        <div className={`stages-settings__stage--color ${stage.key} rounded me-2`}></div>
        <div className="fs-large">{stage.label}</div>
      </div>
      <span className="text-muted">
        {stagesDescription[stage.key]}
      </span>
    </div>
  );
}

StageLabel.propTypes = {
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
};
